import { LazyMotion, m } from 'framer-motion'
import styled from 'styled-components'
import Icon from '@/components/icon'

const loadFeatures = () => import('./features.js').then(res => res.default)

const variants = {
  open: {
    transform: 'translateX(100%)',
    left: -16
  },
  closed: {
    transform: 'translateX(0%)',
    left: 0
  }
}

const ArrowWrapper = styled.span`
  display: flex;

  transform: translateX(0%);
  align-items: center;
  position: relative;
  height: 20px;
`

const ArrowIcon = styled(Icon)<{ align: Align }>`
  transition: transform 300ms ease-in-out 0s;
  transform: rotate(90deg) scale(0.6);
  margin-top: 1px;
  flex-shrink: 0;
  vertical-align: ${props => props.align};
`

type Align = 'baseline' | 'middle'
type ArrowProps = {
  isOpen: boolean
  align?: Align
}

const Arrow: React.FC<ArrowProps> = ({ isOpen, align }) => {
  const state = isOpen ? 'open' : 'closed'
  return (
    <LazyMotion features={loadFeatures}>
      <ArrowWrapper
        as={m.span}
        initial={state}
        animate={state}
        exit={state}
        variants={variants}
        transition={{ type: 'spring', damping: 18, mass: 1.3, stiffness: 95 }}
      >
        <ArrowIcon id="arrow" height={10} width={16} align={align} />
      </ArrowWrapper>
    </LazyMotion>
  )
}

export default Arrow
